// extracted by mini-css-extract-plugin
module.exports = {"content":"delete-wishlist-dialog_content__5j44N","wrapper":"delete-wishlist-dialog_wrapper__pG7Lf"};